import { useState } from 'react';
import { contactContent } from '@/mocks/homeData';

function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      return;
    }

    formData.delete('phone_alt');

    try {
      const res = await fetch('https://readdy.ai/api/form/d9m7ltgbdkpk99j7g7ng', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && (parsed as { code?: string }).code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = (parsed as { meta?: { message?: string } }).meta?.message
          || (parsed as { message?: string }).message
          || responseText
          || '提交失败，请稍后再试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络异常，请检查网络后重试');
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="mt-6 bg-primary-500/10 border border-primary-500/20 rounded-lg p-5 text-center">
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/20 text-primary-500 mx-auto mb-3">
          <i className="ri-check-line text-xl"></i>
        </div>
        <p className="text-sm font-medium text-foreground-200">留言已发送成功！</p>
        <p className="text-xs text-foreground-400 mt-1">我们将在24小时内回复您</p>
      </div>
    );
  }

  return (
    <form className="mt-6 space-y-4" data-readdy-form onSubmit={handleSubmit}>
      {status === 'error' && (
        <div className="bg-accent-500/10 border border-accent-500/20 rounded-lg p-3 text-sm text-accent-400">
          {errorMsg}
        </div>
      )}
      <input
        type="text"
        name="name"
        placeholder="您的称呼"
        className="w-full px-4 py-3 bg-background-100 border border-background-300/40 rounded-lg text-sm text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
      />
      <input
        type="email"
        name="email"
        placeholder="您的邮箱"
        className="w-full px-4 py-3 bg-background-100 border border-background-300/40 rounded-lg text-sm text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
      />
      <textarea
        name="message"
        rows={4}
        maxLength={500}
        placeholder="请输入您的留言内容（500字以内）"
        className="w-full px-4 py-3 bg-background-100 border border-background-300/40 rounded-lg text-sm text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors resize-none"
      ></textarea>
      <input
        type="text"
        name="phone_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="antispam-field"
      />
      <button
        type="submit"
        className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
      >
        发送留言
      </button>
    </form>
  );
}

export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 text-center mb-3">
          {contactContent.title}
        </h2>
        <p className="text-foreground-400 text-sm text-center mb-10 max-w-md mx-auto">
          {contactContent.desc}
        </p>

        <div className="max-w-md mx-auto bg-background-50 border border-background-200/30 rounded-xl p-6 md:p-8">
          <div className="space-y-5">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 shrink-0">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                <p className="text-sm font-medium text-foreground-200">{contactContent.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500/10 text-secondary-400 shrink-0">
                <i className="ri-time-line text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">工作时间</p>
                <p className="text-sm font-medium text-foreground-200">{contactContent.workTime}</p>
              </div>
            </div>
          </div>

          <ContactForm />
        </div>
      </div>
    </section>
  );
}